import Layout from "../../Internal/Layout.vue";
import OrdersPage from "./Orders.vue";
import OrdersDetailPage from "./OrdersDetail.vue";
import OrdersResalePage from "./OrdersResale.vue";
import OrdersDetailResalePage from "./OrdersDetailResale.vue";

const OrdersRoutes = {
  component: Layout,
  children: [
    {
      path: "/orders",
      name: "Orders",
      component: OrdersPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
      },
    },
    {
      path: "/order-detail",
      name: "OrdersDetail",
      component: OrdersDetailPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresResale: true,
      },
    },
    {
      path: "/orders-resale",
      name: "OrdersResale",
      component: OrdersResalePage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresResale: true,
      },
    },
    {
      path: "/order-detailresale",
      name: "OrdersDetailResale",
      component: OrdersDetailResalePage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresResale: true,
      },
    },
  ],
};

export default OrdersRoutes;
